import IMAGES from "utils/images";
import iphone18ProJson from "./iphone18Pro.json";
import iphone18ProMaxJson from "./iphone18ProMax.json";
import iphoneDuoJson from "./iphoneDuo.json";
import watchUltra4Json from "./watchUltra4.json";
import watch12GpsJson from "./watch12GPS.json";
import watch12CellularJson from "./watch12CELLULAR.json";

const { image5, image4, image3, image7, ip15, image6 } = IMAGES;

export const CAPACITYS = [
  {
    capacityKey: "128GB",
    name: "128GB",
  },
  {
    capacityKey: "256GB",
    name: "256GB",
  },
  {
    capacityKey: "512GB",
    name: "512GB",
  },
  {
    capacityKey: "1TB",
    name: "1TB",
  },
];

export const COLORS = [
  {
    color: "#000000",
    colorKey: "#000000",
    colorName: "Đen",
  },
  {
    color: "#DAE2E6",
    colorKey: "#DAE2E6",
    colorName: "Xanh Da Trời",
  },
  {
    color: "#CED9C8",
    colorKey: "#CED9C8",
    colorName: "Xanh Lá Cây",
  },
  {
    color: "#E6E0C2",
    colorKey: "#E6E0C2",
    colorName: "Vàng",
  },
  {
    color: "#F2ADDA",
    colorKey: "#F2ADDA",
    colorName: "Hồng",
  },
  {
    color: "#363636",
    colorKey: "#363636",
    colorName: "Titan Đen",
  },
  {
    color: "#C2BCB2",
    colorKey: "#C2BCB2",
    colorName: "Titan Tự Nhiên",
  },
  {
    color: "#F2F1ED",
    colorKey: "#F2F1ED",
    colorName: "Titan Trắng",
  },
  {
    color: "#FFFFFF",
    colorKey: "#FFFFFF",
    colorName: "Trắng",
  },
  {
    color: "#C0A48F",
    colorKey: "#C0A48F",
    colorName: "Titan Sa Mạc",
  },
  {
    color: "#1B4D80",
    colorKey: "#1B4D80",
    colorName: "Titan Xanh Da Trời",
  },
  {
    colorKey: "#4c4b49",
    color: "#4c4b49",
    colorName: "Space Black",
  },
  {
    colorKey: "#e3e5e3",
    color: "#e3e5e3",
    colorName: "Sliver",
  },
  {
    colorKey: "#fcebd3",
    color: "#fcebd3",
    colorName: "Gold",
  },
  {
    colorKey: "#61586b",
    color: "#61586b",
    colorName: "Deep Purple",
  },
  {
    colorKey: "#B0D4D2",
    color: "#B0D4D2",
    colorName: "Xanh Mòng Két",
  },
  {
    colorKey: "#9BADF6",
    color: "#9BADF6",
    colorName: "Xanh Lưu Ly",
  },
  {
    colorKey: "#A7BDDD",
    color: "#A7BDDD",
    colorName: "Xanh Lam Khói",
  },
  {
    colorKey: "#E9DAF1",
    color: "#E9DAF1",
    colorName: "Tím Oải Hương",
  },
  {
    colorKey: "#B9C69B",
    color: "#B9C69B",
    colorName: "Xanh Lá Xô Thơm",
  },
  {
    colorKey: "#F87E33",
    color: "#F87E33",
    colorName: "Cam Vũ Trụ",
  },
  {
    colorKey: "#424E7A",
    color: "#424E7A",
    colorName: "Xanh Đậm",
  },
  {
    colorKey: "#f1f1f1",
    color: "#f1f1f1",
    colorName: "Bạc",
  },
  {
    colorKey: "#181818",
    color: "#181818",
    colorName: "Đen Không Gian",
  },
  {
    colorKey: "#FCFCFC",
    color: "#FCFCFC",
    colorName: "Trắng Mây",
  },
  {
    colorKey: "#FAF3E5",
    color: "#FAF3E5",
    colorName: "Vàng Nhạt",
  },
  {
    colorKey: "#E5F2FA",
    color: "#E5F2FA",
    colorName: "Xanh Da Trời",
  },
  {
    colorKey: "#4A0F1B",
    color: "#4A0F1B",
    colorName: "Dark C",
  },
  {
    colorKey: "#272729",
    color: "#272729",
    colorName: "Black",
  },
  {
    colorKey: "#4e2e34",
    color: "#4e2e34",
    colorName: "Burgundy",
  },
  {
    colorKey: "#aab6c8",
    color: "#aab6c8",
    colorName: "Glacier",
  },
  {
    colorKey: "#cfcfce",
    color: "#cfcfce",
    colorName: "Silver",
  },
  {
    colorKey: "#4E5560",
    color: "#4E5560",
    colorName: "Night Sky",
  },
  {
    colorKey: "#F7F5F4",
    color: "#F7F5F4",
    colorName: "Star White",
  }
];

export const VERSION = [
  {
    versionKey: "no",
    versionName: "Sạc không dây",
  },
  {
    versionKey: "have",
    versionName: "Sạc có dây",
  },
];

export const SIZE = [
  {
    sizeKey: "41mm",
    sizeName: "41mm",
  },
  {
    sizeKey: "45mm",
    sizeName: "45mm",
  },
];

export const MODEL_KEY = {
  AIRPODS: 205,
  WATCH: 206,

  WATCHULTRA2: 545,
  WATCHSERIES9: 541,
  WATCHSE: 544,
  AIRPODSPRO2: 333,

  IPHONE16: 645,
  IPHONE16PLUS: 646,
  IPHONE16PRO: 647,
  IPHONE16PROMAX: 648,

  WATCHULTRA2024: 633,
  WATCHSERIES10: 634,

  AIRPODS4: 635,
  AIRPODSMAX: 636,

  IPHONE17: 703,
  IPHONE17PRO: 704,
  IPHONE17PROMAX: 705,
  IPHONEAIR: 706,

  AIRPODPRO3: 708,
  WATCHULTRA3: 709,
  WATCHSE3: 710,
  WATCHSERIES11: 711,

  IPHONENPROMAX: 736,

  IPHONE18PRO: 738,
  IPHONE18PROMAX: 737,
  IPHONEDUO: 739,

  WATCHULTRA4: 750,
  WATCHSERIES12GPS: 751,
  WATCHSERIES12CELLULAR: 753,

  AIRPODS5: 740,
};

export const MODELS = [
  {
    modelId: MODEL_KEY.WATCH,
    modelName: "Apple Watch Series 8",
    imageUrl: image7,
  },
  {
    modelId: MODEL_KEY.AIRPODS,
    modelName: "AirPods Pro",
    imageUrl: image6,
  },
  {
    modelId: MODEL_KEY.IPHONE16,
    modelName: "iPhone 16",
    imageUrl: image5,
  },
  {
    modelId: MODEL_KEY.IPHONE16PLUS,
    modelName: "iPhone 16 Plus",
    imageUrl: image4,
  },
  {
    modelId: MODEL_KEY.IPHONE16PRO,
    modelName: "iPhone 16 Pro",
    imageUrl: image3,
  },
  {
    modelId: MODEL_KEY.IPHONE16PROMAX,
    modelName: "iPhone 16 Pro Max",
    imageUrl: ip15,
  },
];

export const PRODUCTS_ACCESSORIES = [
];

export const PRODUCTS = [
  ...iphone18ProJson,
  ...iphone18ProMaxJson,
  ...iphoneDuoJson,
  ...watchUltra4Json,
  ...watch12GpsJson,
  ...watch12CellularJson,
  {
    modelId: MODEL_KEY.AIRPODS5,
    productId: 5397,
    productName: "AirPods 5",
    price: 6799000,
    productCode: "MKFW4ZP/A",
    imageUrl: IMAGES.airpodspro3,
  },
]

export const findProduct = ({ modelId, colorKey, capacityKey }) => {
  let product = null;
  if (modelId && !colorKey && !capacityKey) {
    return PRODUCTS.find((x) => x.modelId === modelId);
  } else {
    product = PRODUCTS.find(
      (x) =>
        x.modelId === modelId &&
        x.colorKey === colorKey &&
        x.capacityKey === capacityKey
    );
    if (!product) {
      product = PRODUCTS.find(
        (x) => x.modelId === modelId && x.colorKey === colorKey
      );
    }
    if (!product) {
      product = PRODUCTS.find((x) => x.modelId === modelId);
    }
  }
  return product ? product : PRODUCTS[0];
};

export const settingSlider = {
  slidesToShow: 4,
  slidesToScroll: 4,
  infinite: false,
  responsive: [
    {
      breakpoint: 1920,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 4,
      },
    },
    {
      breakpoint: 1000,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
      },
    },
    {
      breakpoint: 769,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
      },
    },
  ],
};
